export default class FilterService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate), modifiedDate: new Date(json.modifiedDate) });
    }
    static get CaseloadFilterId() {
        return 1;
    }
    static get EveryoneFilterId() {
        return 2;
    }
    static get DefaultFilterId() {
        return FilterService.CaseloadFilterId;
    }
}
